export { StaticDateRangePicker } from './StaticDateRangePicker';
export type {
  StaticDateRangePickerProps,
  StaticDateRangePickerSlots,
  StaticDateRangePickerSlotProps,
} from './StaticDateRangePicker.types';
